import { render, staticRenderFns } from "./EndScreen.vue?vue&type=template&id=2327b7aa&"
import script from "./EndScreen.vue?vue&type=script&lang=js&"
export * from "./EndScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports